import { render, staticRenderFns } from "./PayStat.vue?vue&type=template&id=15546580&"
import script from "./PayStat.vue?vue&type=script&lang=js&"
export * from "./PayStat.vue?vue&type=script&lang=js&"
import style0 from "./PayStat.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports